"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import PromotionBannerConnector from "./PromotionBannerConnector";
import { returnActivePromotionBanner } from "./PromotionBannerMethods";
import { PromotionBannerContext } from "./PromotionBannerContext";
const PromotionBannersWrapper = t0 => {
  const $ = _c(10);
  const {
    promoBannersData,
    lang
  } = t0;
  const {
    pageSpecificBanner,
    hideAllSitewide
  } = useContext(PromotionBannerContext);
  if (pageSpecificBanner != null) {
    let t1;
    if ($[0] !== pageSpecificBanner) {
      t1 = returnActivePromotionBanner(Array.isArray(pageSpecificBanner) ? pageSpecificBanner : [pageSpecificBanner]) || null;
      $[0] = pageSpecificBanner;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const activePromoBanners = t1;
    if (!activePromoBanners?.length) {
      return null;
    }
    let t2;
    if ($[2] !== activePromoBanners[0] || $[3] !== lang) {
      t2 = <PromotionBannerConnector promotionBanner={activePromoBanners[0]} lang={lang} />;
      $[2] = activePromoBanners[0];
      $[3] = lang;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (hideAllSitewide) {
    return null;
  }
  if (!promoBannersData?.length) {
    return null;
  }
  let t1;
  if ($[5] !== promoBannersData) {
    t1 = returnActivePromotionBanner(promoBannersData) || null;
    $[5] = promoBannersData;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const activePromoBanners_0 = t1;
  if (!activePromoBanners_0?.length) {
    return null;
  }
  let t2;
  if ($[7] !== activePromoBanners_0[0] || $[8] !== lang) {
    t2 = <PromotionBannerConnector promotionBanner={activePromoBanners_0[0]} lang={lang} />;
    $[7] = activePromoBanners_0[0];
    $[8] = lang;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default PromotionBannersWrapper;